const INVENTORY_SCHEMA = null;
module.exports = INVENTORY_SCHEMA